import { download, generateCsv, mkConfig } from "export-to-csv"
import { useMoney } from "../../../../currency/useMoney"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { StandardExportButton } from "../../../../../shared/components/table/StandardExportButton"
import { FetchProductSalesResponse } from "../accountingApi"
import { toDinero } from "../../../../currency/currencyLib"

interface ExportButtonProductSalesProps {
    data?: FetchProductSalesResponse | undefined
    startDate: string
    endDate: string
    className?: string
}

export const ExportButtonProductSales = ({ data, startDate, endDate, className }: ExportButtonProductSalesProps) => {
    const { l10n } = useAppLocalization()
    const periodTranslation = l10n.getString("export-period")
    const moneyFactory = useMoney({})

    const handleExportRows = (data: FetchProductSalesResponse | undefined) => {
        const csvOptions = mkConfig({
            fieldSeparator: ";",
            quoteStrings: true,
            decimalSeparator: ".",
            useBom: true,
            useKeysAsHeaders: true,
            showColumnHeaders: false,
            filename: `Facilitynet-ProductSales-${startDate}_${endDate}`,
        })

        if (data?.productGroups) {
            const exportRowsForBalance = data.productGroups.flatMap((productGroup) => [
                {
                    column1: productGroup.name,
                    column2: `Beløb (${productGroup.totalAmount.currency})`,
                    column3: "Sold items",
                    column4: "Total",
                },
                ...productGroup.productSales.map((product) => ({
                    column1: product.name,
                    column2: moneyFactory.formatAsNumber(toDinero(product.amount)),
                    column3: product.numberOfOrders,
                    column4: "",
                })),
                {
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: moneyFactory.formatAsNumber(toDinero(productGroup.totalAmount)),
                },
                {
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                },
            ])

            exportRowsForBalance.unshift({
                column1: "",
                column2: "",
                column3: "",
                column4: "",
            })

            exportRowsForBalance.unshift({
                column1: `${periodTranslation} ${startDate} - ${endDate}`,
                column2: "",
                column3: "",
                column4: "",
            })

            const csv = generateCsv(csvOptions)(exportRowsForBalance)
            download(csvOptions)(csv)
        } else {
            const exportRowsForEmptyList = [
                {
                    column1: `${periodTranslation} ${startDate} - ${endDate}`,
                },
                {
                    column1: "",
                },
                {
                    column1: `${l10n.getString("accounting-product-sale-export-empty")}`,
                },
            ]
            const csv = generateCsv(csvOptions)(exportRowsForEmptyList)
            download(csvOptions)(csv)
        }
    }

    return <StandardExportButton className={className} onClick={() => handleExportRows(data)} />
}
